export const SOURCE_RETURN_HREF_KEY = 'ss_source_return_href';

export function applicationSourceReturnHref(daId) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(daId || '')
    ? `/application?id=${encodeURIComponent(daId)}` : sourceBackTargetFromSearch();
}

export function safeInternalReturnHref(value) {
  const raw = String(value || '').trim();
  if (!raw || !raw.startsWith('/') || raw.startsWith('//')) return null;

  try {
    const origin = window.location.origin || 'https://app.sitescope.local';
    const url = new URL(raw, origin);
    if (url.origin !== origin) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function readSourceReturnHref() {
  try {
    return safeInternalReturnHref(window.sessionStorage?.getItem(SOURCE_RETURN_HREF_KEY));
  } catch {
    return null;
  }
}

export function writeSourceReturnHref(value) {
  const href = safeInternalReturnHref(value);
  if (!href) return;

  try {
    window.sessionStorage?.setItem(SOURCE_RETURN_HREF_KEY, href);
  } catch {}
}

export function clearSourceReturnHref() {
  try {
    window.sessionStorage?.removeItem(SOURCE_RETURN_HREF_KEY);
  } catch {}
}

export function buildSavedSearchReturnHref({ query, councils, statuses, categories } = {}) {
  const params = new URLSearchParams();
  const searchQuery = String(query || '').trim();
  if (searchQuery) params.set('q', searchQuery);
  if (Array.isArray(councils) && councils.length > 0) params.set('councils', councils.join(','));
  if (Array.isArray(statuses) && statuses.length > 0) params.set('statuses', statuses.join(','));
  if (Array.isArray(categories) && categories.length > 0) params.set('categories', categories.join(','));
  const queryString = params.toString();
  return queryString ? `/saved-search?${queryString}` : '/';
}

export function sourceBackTargetFromSearch(search = window.location.search) {
  const params = new URLSearchParams(search);
  return safeInternalReturnHref(params.get('return')) || readSourceReturnHref();
}

export function addReturnParam(path, returnHref = sourceBackTargetFromSearch()) {
  const href = safeInternalReturnHref(path);
  if (!href) return path;
  const target = new URL(href, window.location.origin || 'https://app.sitescope.local');
  const safeReturnHref = safeInternalReturnHref(returnHref);
  if (safeReturnHref) target.searchParams.set('return', safeReturnHref);
  return `${target.pathname}${target.search}${target.hash}`;
}

export function sourceBackHref() {
  return sourceBackTargetFromSearch() || '/app';
}

export function goBackToSiteScope() {
  window.location.assign(sourceBackHref());
}
